import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();


  if (!user && loading) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
